"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./Loader.css"));
var _ContentLayout = require("../ContentLayout");
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Loader = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: style['loader']
  }, /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement("div", {
    className: style['skeleton--row']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['skeleton--block']
  })), /*#__PURE__*/React.createElement("div", {
    className: style['skeleton--row']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['skeleton--text']
  }), /*#__PURE__*/React.createElement("div", {
    className: style['skeleton--block']
  })), /*#__PURE__*/React.createElement("div", {
    className: style['skeleton--row']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['skeleton--text']
  }), /*#__PURE__*/React.createElement("div", {
    className: style['skeleton--block']
  }))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true
  }, /*#__PURE__*/React.createElement("div", {
    className: style['controls']
  }, /*#__PURE__*/React.createElement(_uiKit.Button, {
    size: "M",
    loading: true,
    fullWidth: true
  }, "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430"))));
};
exports.Loader = Loader;